// extracted by mini-css-extract-plugin
export default {"cell_phone":"CellPhone_cell_phone__eVcYz","container":"CellPhone_container__FEtpO"};